module.exports = __webpack_public_path__ + "static/img/about_h5bg_04_zh.136103d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_h5bg_04_zh.png
// module id = WEY/
// module chunks = 34